import React, {Component} from 'react';
import './Leaveapplication.css';
import AuthService from "../services/auth.service";
import axios from 'axios';
import moment from 'moment'
class  Leaveapplication extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           show:"",
            leave:[],
            list:[]
            
          };
       
    }
    fetchData(){
        const USR_TOKEN = localStorage.getItem("userToken")
       
                axios.get(process.env.REACT_APP_API_URL + 'api/resource/Leave Type', {
                    headers : {'Authorization' : USR_TOKEN, 
                'content-type': 'application/json'}
                })
                .then(response=>{
                        this.setState({list:response.data.data})
                        //alert("ok")
                })
                .catch(error=>{
                    //window.location.href = "/";
                    //this.setState({name:response.data['data'][0]})
                    //console.log(err)
                    console.log(error.message)
                })
               
    }

    componentDidMount(){
        this.fetchData()
        
    }

     async applyLeave (){


        //let fromdate=moment(this.From).format('YYYY-MM-DD')
        //let todate=moment(this.To).format('YYYY-MM-DD')





        const leaveData ={
            leave_type:this.LeaveType,
            from_date:this.From,
            to_date:this.To,
            description:this.Dec
        }

        
       
        const USR_TOKEN = localStorage.getItem("userToken")
        let resStatus = 0
                axios.post(process.env.REACT_APP_API_URL + 'api/resource/Leave Application',leaveData, {
                    headers : {'Authorization' : USR_TOKEN, 
                'content-type': 'application/json'}
                })
                .then(response=>{
                    
                        //this.setState({leave:response.data.data})
                        //console.log(response)
                        alert("Leave applied");
                        
                       
                })
               /*  .catch(error =>{
                    //window.location.href = "/";
                    //this.setState({name:response.data['data'][0]})
                    //console.log(err.message)
                    //this.setState({errorMessage: err.message});
                    //console.log(err.response.data)
                    console.log(error)
                    //alert(err)
                   
                }) */

                .catch(err=> {

                    console.log(err);
                    alert("Something went wrong");
        
                });

                
                
                  /* const response=await axios.post(process.env.REACT_APP_API_URL + 'api/resource/Leave Application',leaveData, {
                    headers : {'Authorization' : USR_TOKEN, 
                'content-type': 'application/json'}
                })

                  console.log(response.data)  */
    }

  render() {
      
        return <div>
                    <h4 className="text-center col-md-12">New Leave Application</h4>
                    <form className="myForm" >
                        <div className="row">
                            <div className="col-md-6">
                                <div>
                                    <label className="mb-1">Leave Type
                                    <select id="pickup_place" name="pickup_place" className="mt-1" onChange={e=>this.LeaveType = e.target.value}>
                                    <option value="" selected="selected">Select One</option>
                                   {this.state.list ?  this.state.list.map((itm,k)=>{
                             
                             return( 
                                    <option value={itm.name} key={k}>{itm.name}</option>
                                     )
                                                }):""} 
                                    </select>
                                    </label> 
                                </div>
                                <div className="mt-1">
                                    <label className="mb-1">From Date:</label>
                                    <div className="">
                                        <input type="date" id="from" className="mydatepicker" onChange={e=>this.From = e.target.value}/>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <label className="mb-1">To Date:</label>
                                    <div className="">
                                        <input type="date" id="to" className="mydatepicker" onChange={e=>this.To = e.target.value}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="">
                                    <label >Reason
                                        <textarea maxlength="1000" id="demo" className="mt-1" onChange={e=>this.Dec = e.target.value}/>
                                    </label>
                                </div>
                               
                            </div>
                        </div>
                    </form>  

                     <div>
                        <button className="float-right submit-button" type="button" onClick={() => this.applyLeave()}>Submit</button>
                    </div>       
                </div>
}
}
export default Leaveapplication;